/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type TransportSchemeTicketKind = typeof TransportSchemeTicketKind[keyof typeof TransportSchemeTicketKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransportSchemeTicketKind = {
  Primary: 'Primary',
  Connected: 'Connected',
  Bus: 'Bus',
} as const;
